<template>
  <div class="row">
    <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
      <fg-input
        type="text"
        :label="`${$t('common_words.name')}: *`"
        v-model="model.responsable_name"
        name="common_words.name"
        v-validate="modelValidations.responsable_name"
        :error="getError('common_words.name', true)"
        placeholder="..."
      >
      </fg-input>
    </div>
    <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
      <fg-input
        type="text"
        :label="`${$t('common_words.surname')}: *`"
        v-model="model.responsable_last_name"
        name="common_words.surname"
        v-validate="modelValidations.responsable_last_name"
        :error="getError('common_words.surname', true)"
        placeholder="..."
      >
      </fg-input>
    </div>
    <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
      <fg-input
        type="number"
        :label="`${$t('common_words.phone')}: *`"
        v-model="model.responsable_phone"
        name="common_words.phone"
        v-validate="modelValidations.responsable_phone"
        :error="getError('common_words.phone', true)"
        placeholder="..."
      >
      </fg-input>
    </div>
    <div class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6">
      <fg-input
        type="email"
        :label="`${$t('common_words.email')}: *`"
        v-model="model.responsable_email"
        name="common_words.email"
        v-validate="modelValidations.responsable_email"
        :error="getError('common_words.email', true)"
        placeholder="..."
      >
      </fg-input>
    </div>
  </div>
</template>
<script>
import MixinAlert from 'src/mixins/mixin-alert';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations.js';

export default {
  components: {},
  data() {
    return {
      model: {
        responsable_name: null,
        responsable_last_name: null,
        responsable_phone: null,
        responsable_email: null,
      },
      modelValidations: {
        responsable_name: { required: true },
        responsable_last_name: { required: true },
        responsable_phone: { required: true, numeric: true },
        responsable_email: { required: true, email: true },
      },
    };
  },
  mixins: [
    MixinPermissions,
    MixinForm,
    MixinAlert,
    MixinLoading,
    MixinValidations,
  ],
  methods: {
    validate() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.$emit('on-validated', this.model);
          
          return isValid;
        }
      });
    },
  },
  mounted() {
    let editForm = {};
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      editForm = JSON.parse(sessionStorage.getItem('editForm'));
      const {
        responsable_name,
        responsable_last_name,
        responsable_phone,
        responsable_email
      } = editForm
      this.model = {
        ...this.model,
        responsable_name,
        responsable_last_name,
        responsable_phone,
        responsable_email
      };
    }
  },
};
</script>
